<template>
  <el-table-column
    prop="address.country.name"
    label="Ország"
    show-overflow-tooltip
    min-width="150"
    sortable="custom"
  >
    <template slot-scope="scope">
      <div v-if="scope.row.address && scope.row.address.country" style="display: inline-block;">
        {{ scope.row.address.country.name }}
      </div>
      <div v-else>-</div>
    </template>
  </el-table-column>
</template>
<script>
  export default {
    propName: 'address.country.name',
  };
</script>
